<template>
  <div class="dai">
    <div class="dai-head">
      <div class="dai-head-ico">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16zM3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/>
        </svg>
      </div>
      <div>
        <div class="dai-title">Insights da IA</div>
        <div class="dai-sub">{{ loading ? 'Analisando dados...' : `${insights.length} recomendações para hoje` }}</div>
      </div>
    </div>
    <div v-if="loading" class="dai-skeleton">
      <div v-for="i in 3" :key="i" class="dai-skel-card">
        <div class="dai-skel-line dai-skel-tag"></div>
        <div class="dai-skel-line dai-skel-title"></div>
        <div class="dai-skel-line dai-skel-desc"></div>
      </div>
    </div>
    <div v-else class="dai-list">
      <dash-insight-card
        v-for="(ins, i) in insights"
        :key="i"
        :insight="ins"
        @cta="handleCta"
      />
    </div>
  </div>
</template>

<script>
import DashInsightCard from './DashInsightCard.vue'
export default {
  name: 'DashAiInsights',
  components: { DashInsightCard },
  props: {
    insights: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCta(insight) {
      const raw = [insight.cta, insight.title, insight.tag].filter(Boolean).join(' ').toLowerCase()
      const navigate = (target) => {
        if (this.$router && typeof this.$router.push === 'function') {
          this.$router.push(target)
        } else if (typeof target === 'string') {
          window.location.href = target
        } else if (target && target.path) {
          window.location.href = target.path
        }
      }

      if (insight.route) {
        navigate(insight.route)
        return
      }

      if (insight.href) {
        window.open(insight.href, '_blank', 'noopener')
        return
      }

      if (raw.includes('heatmap') || raw.includes('mapa de calor')) {
        navigate({ name: 'heatmap' })
        return
      }

      if (
        raw.includes('thumbnail') ||
        raw.includes('thumb') ||
        raw.includes('vsl') ||
        raw.includes('video') ||
        raw.includes('abertura') ||
        raw.includes('cta') ||
        raw.includes('proposta') ||
        raw.includes('copy')
      ) {
        navigate({ name: 'Meus-Videos' })
        return
      }

      navigate({ name: 'app-dashboard' })
    },
  },
}
</script>

<style>
.dai {
  background: linear-gradient(180deg, rgba(22,29,43,.8), rgba(16,21,31,.9));
  border: 1px solid var(--wr-line-2);
  border-radius: 16px;
  padding: 22px;
  font-family: 'Inter', sans-serif;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.dai-head { display: flex; align-items: flex-start; gap: 12px; margin-bottom: 16px; }
.dai-head-ico {
  width: 32px; height: 32px;
  border-radius: 9px;
  background: linear-gradient(135deg, rgba(232,106,16,.2), rgba(245,185,53,.2));
  color: #F08023;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dai-title { font-size: 14.5px; font-weight: 800; color: var(--wr-text); }
.dai-sub { font-size: 12px; color: var(--wr-mute); margin-top: 2px; }
.dai-list { display: flex; flex-direction: column; gap: 10px; }

.dai-skeleton { display: flex; flex-direction: column; gap: 10px; }
.dai-skel-card {
  background: rgba(255,255,255,.04);
  border: 1px solid rgba(255,255,255,.07);
  border-radius: 10px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
  position: relative;
}
.dai-skel-card::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255,255,255,.05), transparent);
  animation: dai-shimmer 1.4s infinite;
}
@keyframes dai-shimmer {
  100% { transform: translateX(100%); }
}
.dai-skel-line { background: rgba(255,255,255,.08); border-radius: 4px; }
.dai-skel-tag   { height: 16px; width: 40%; }
.dai-skel-title { height: 14px; width: 80%; }
.dai-skel-desc  { height: 12px; width: 90%; }
</style>
